// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tool-box[data-v-45d5c89a] {\n  padding-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
